import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";

export async function postToEventGrid(payload) {
  const baseUrl = window.location.pathname.replace(/\/$/, "");
  try {
    const response = await requestHelper.post({
      url: `${baseUrl}/submit-withdrawal`,
      headers: {
        "Content-Type": "application/json",
      },
      body: payload,
    });

    if (response.status !== 200) {
      throw new Error("Failed to post to event grid.");
    }

    return response;
  } catch (error) {
    noticeError(error);
    throw new Error("Failed to post to event grid.", { cause: error });
  }
}
